import React from "react";
import { Container, Grid, Box, Skeleton } from "@mui/material";

const PostDetailsPageSkeleton = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh" }}>
      <Container maxWidth={false} sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={8}>
            <Box mb={4}>
              <Skeleton variant="text" width="60%" height={60} />
              <Box display="flex" alignItems="center" mt={2}>
                <Skeleton variant="circular" width={56} height={56} />
                <Box ml={2}>
                  <Skeleton variant="text" width={120} height={24} />
                  <Skeleton variant="text" width={80} height={20} />
                </Box>
              </Box>
            </Box>

            <Skeleton variant="rectangular" width="100%" height={400} sx={{ mb: 4, borderRadius: "4px" }} />

            <Box mb={4}>
              <Skeleton variant="text" width="30%" height={40} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
              <Skeleton variant="text" width="80%" height={24} />
            </Box>

            <Skeleton variant="rectangular" width="100%" height={200} sx={{ mb: 4, borderRadius: "4px" }} />
            <Skeleton variant="rectangular" width="100%" height={200} sx={{ mb: 4, borderRadius: "4px" }} />
          </Grid>

          <Grid item xs={12} lg={4}>
            <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: "4px" }} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PostDetailsPageSkeleton;